import { render, staticRenderFns } from "./DashboardSkeleton.vue?vue&type=template&id=90cb4ac4&scoped=true&"
import script from "./DashboardSkeleton.vue?vue&type=script&lang=js&"
export * from "./DashboardSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSkeleton.vue?vue&type=style&index=0&id=90cb4ac4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90cb4ac4",
  null
  
)

export default component.exports